export const CAMPAIGN_STATUS = {
  ALL: "",
  SCHEDULE: "scheduled",
  IN_PROGRESS: "in_progress",
  STOPPED: "stopped",
  COMPLETED: "completed",
  TEST: "testing",
} as const;

export const CAMPAIGN_CHANNEL = {
  CALL: "call",
  SMS: "sms",
  WHATSAPP: "whatsapp",
  EMAIL: "email",
} as const;

export const MESSAGING_CAMPAIGN_CHANNELS = [
  CAMPAIGN_CHANNEL.SMS,
  CAMPAIGN_CHANNEL.WHATSAPP,
] as const;

export const normalizeCampaignChannel = (value?: string) => {
  const raw = String(value || "call").toLowerCase();
  if (raw.includes("whatsapp") || raw === "forum") return "whatsapp";
  if (raw.includes("mail") || raw.includes("email")) return "email";
  if (raw.includes("sms") || raw.includes("text")) return "sms";
  return "call";
};

export const isMessagingCampaignChannel = (channel?: string) => {
  const normalized = normalizeCampaignChannel(channel);
  return (
    normalized === CAMPAIGN_CHANNEL.SMS ||
    normalized === CAMPAIGN_CHANNEL.WHATSAPP
  );
};

export const isCampaignGreetingChannel = (channel?: string) => {
  const normalized = normalizeCampaignChannel(channel);
  return (
    normalized === CAMPAIGN_CHANNEL.SMS ||
    normalized === CAMPAIGN_CHANNEL.WHATSAPP ||
    normalized === CAMPAIGN_CHANNEL.EMAIL
  );
};